module.exports = __webpack_public_path__ + "static/media/stat-dependencias.544c4c54.png";